import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState, store } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { ContactState } from './state';
import { ContactActions, ContactActionType } from './action-types';
import { CONTACT } from './mutation-types';
import ContactService, { FilterContacts } from '../service/ContactService';
import { Interlocuteur } from '@/models/Interlocuteur';
import { ContactDTO } from '@/models/ContactDto';

export const actions: ActionTree<ContactState, RootState> = {

    async [ContactActions.GET_INTERLOCUTEURS_LIST]({ commit }: ContactActionType): Promise<void> {
        commit(CONTACT.SET_INTERLOCUTEURS_LOADING, true);
        ContactService.getInterlocuteurs(store.getters['contactState/getSite'].id)
            .then(async (response: any) => {
                if (response !== undefined || response.status !== undefined) {
                    if (response.status !== 200) {
                        commit(CONTACT.SET_INTERLOCUTEURS_LOADING, false);
                        commit(`errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    const interlocuteurs: Interlocuteur[] = response.data;
                    commit(CONTACT.SET_LISTE_INTERLOCUTEURS, interlocuteurs);
                    commit(CONTACT.SET_INTERLOCUTEURS_LOADING, false);
                } else {
                    commit(CONTACT.SET_INTERLOCUTEURS_LOADING, false);
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
            }).catch(async error => {
                commit(CONTACT.SET_INTERLOCUTEURS_LOADING, false);
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            });
    },

    async [ContactActions.SEND_MESSAGE]({ commit, state, getters }: ContactActionType): Promise<void> {
        commit(CONTACT.SET_MESSAGE_SENDING, true);
        const contact = new ContactDTO(getters.getInterlocuteur, state.objet, state.description);
        ContactService.sendMessage(contact)
            .then(async (response: any) => {
                if (response !== undefined || response.status !== undefined) {
                    if (response.status !== 200) {
                        commit(CONTACT.SET_MESSAGE_SENDING, false);
                        commit(`errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    commit(CONTACT.SET_MESSAGE_SENDING, false);
                    commit(CONTACT.SET_IS_SUCCESS, true);
                } else {
                    commit(CONTACT.SET_MESSAGE_SENDING, false);
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
            }).catch(async error => {
                commit(CONTACT.SET_MESSAGE_SENDING, false);
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            });
    },

    async [ContactActions.GET_EXPORT_CONTACTS]({ commit }: ContactActionType, payload: FilterContacts): Promise<void> {
        commit(CONTACT.EXPORT_LOADING, true);
        try {
            const response = await ContactService.getExportXlsContacts(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'Contacts.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(CONTACT.EXPORT_LOADING, false);
        } catch (error) {
            commit(CONTACT.EXPORT_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    }
};
